var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"待提交"}},[_c('order-workbench',{attrs:{"show-title":false,"show-announcement-columns":false,"hide-primary-actions":true,"extra-query-params":{ pending_submit_list: 1 }}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a178ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/PendingSubmitList.vue
// module id = Xk8+
// module chunks = 0